import { Outlet } from 'react-router-dom'
import PaymentStatusModals from '../components/Payment/PaymentStatusModals'

const SubscriptionLayout = () => {
  return (
    <div className="w-full h-full bg-[#F4F4F7]">
      <div className="p-6 h-full lg:px-10 max-w-[1440px] mx-auto">
        <Outlet />
      </div>
      <PaymentStatusModals />
    </div>
  )
}

export default SubscriptionLayout
